import { Helmet } from "react-helmet-async";
import { useEffect } from "react";

interface SeoProps {
  title: string;
  description: string;
  path: string;
  ogImage?: string;
  noIndex?: boolean;
}

export function Seo({ title, description, path, ogImage, noIndex }: SeoProps) {
  const url = `https://perchmobile.com${path}`;
  const image = ogImage ?? "https://perchmobile.com/og/default.png";

  useEffect(() => {
    requestAnimationFrame(() => {
      document.dispatchEvent(new Event("prerender-ready"));
    });
  }, []);

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noIndex && <meta name="robots" content="noindex" />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
